import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import { toast } from 'react-toastify';

export default function AdminServicePage() {
  const [services, setServices] = useState([]);
  const [form, setForm] = useState({ title: '', description: '', image: '' });

  const token = localStorage.getItem('token');
  const navigate = useNavigate();

  // 🔐 Redirect if not logged in
  useEffect(() => {
    if (!token) {
      toast.error('Please login first');
      navigate('/admin');
    } else {
      fetchServices();
    }
  }, [token, navigate]);

  const fetchServices = async () => {
    try {
      const res = await api.get('/services');
      setServices(res.data);
    } catch (err) {
      toast.error('Failed to load services');
    }
  };

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.title || !form.description) return toast.error('Fill all fields');

    try {
      await api.post('/services', form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Service added');
      setForm({ title: '', description: '', image: '' });
      fetchServices();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Add failed');
    }
  };

  const handleDelete = async id => {
    if (!window.confirm('Delete this service?')) return;
    try {
      await api.delete(`/services/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Service deleted');
      fetchServices();
    } catch (err) {
      toast.error('Delete failed');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/admin');
  };

  return (
    <div className="container py-5">
<div className="d-flex justify-content-between align-items-center mb-3">
  <h3 className="mb-0">Manage Services</h3>
  <div className="d-flex gap-2">
    <button onClick={() => navigate('/admin/dashboard')} className="btn btn-outline-primary btn-sm">
      ← Dashboard
    </button>
    <button onClick={handleLogout} className="btn btn-outline-secondary btn-sm">
      Logout
    </button>
  </div>
</div>


      <form className="mb-4" onSubmit={handleSubmit}>
        <div className="row g-2">
          <div className="col-md-4">
            <input
              name="title"
              className="form-control"
              placeholder="Service Title"
              value={form.title}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-4">
            <input
              name="description"
              className="form-control"
              placeholder="Service Description"
              value={form.description}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-4">
            <input
              name="image"
              className="form-control"
              placeholder="Image URL (optional)"
              value={form.image}
              onChange={handleChange}
            />
          </div>
        </div>
        <button type="submit" className="btn btn-dark mt-3">Add Service</button>
      </form>

      <div className="row">
        {services.map(service => (
          <div className="col-md-4 mb-4" key={service.id}>
            <div className="card h-100 shadow-sm">
              {service.image && (
                <img src={service.image} className="card-img-top" alt={service.title} />
              )}
              <div className="card-body">
                <h5>{service.title}</h5>
                <p>{service.description}</p>
                <button onClick={() => handleDelete(service.id)} className="btn btn-sm btn-danger">
                  Delete
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
